import { MobileMenuItem } from 'src/app/models/navbar';
import { Link } from 'src/environments/environment.interface';

/** Default link ids for the mobile drawer when `mobileMenu` is omitted from config. */
export const DEFAULT_MOBILE_MENU_IDS = ['pricing'];

const DEFAULT_MOBILE_MENU_URLS: Record<string, string> = {
    pricing: '/purchase',
    classes: '/class-schedule',
    locations: '/locations',
    about: '/about'
};

const DEFAULT_MOBILE_MENU_NAMES: Record<string, string> = {
    pricing: 'Pricing',
    classes: 'Class Schedule',
    locations: 'Locations',
    about: 'About'
};

/**
 * Resolves mobile drawer links from the `mobileMenu` id list.
 * Homepage section `show` flags must not be applied here — those only control homepage tiles.
 */
export function resolveMobileMenuItems(
    menuIds: string[] | undefined,
    getLink: (id: string) => Pick<Link, 'url' | 'name' | 'target'> | undefined
): MobileMenuItem[] {
    const ids = menuIds && menuIds.length > 0 ? [...menuIds] : [...DEFAULT_MOBILE_MENU_IDS];
    const items: MobileMenuItem[] = [];

    for (const id of ids) {
        const link = getLink(id);
        const url = link?.url || DEFAULT_MOBILE_MENU_URLS[id] || '';
        const name = link?.name || DEFAULT_MOBILE_MENU_NAMES[id] || id;

        if (url) {
            items.push({
                id,
                name,
                url,
                target: link?.target || '_self'
            });
        }
    }

    return items;
}
